module.exports = __webpack_public_path__ + "img/emoji-dizzy-fill.9db0b851.svg";